import React from 'react';
import { browserHistory, Router } from 'react-router';
import { Provider, connect } from 'react-redux';
import PropTypes from 'prop-types';

import Loading from './Loading';
import AlertError from './AlertError';

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired, // Ver routes/index.js#createRoutes
    history: PropTypes.object.isRequired,
  }

  shouldComponentUpdate(nextProps, nextState) {
    const doUpdate = nextProps.isLoading !== this.props.isLoading
                      || nextProps.hasErrored !== this.props.hasErrored
                      || nextProps.data !== this.props.data;
    return doUpdate;
  }

  render() {
    const { isLoading, hasErrored, data } = this.props;
    if (isLoading) {
      return (<Loading />);
    }

    if (hasErrored) {
      return (<AlertError />);
    }

    return (
      <Provider store={this.props.store}>
        <Router history={this.props.history} children={this.props.routes} />
      </Provider>
    );
  }
}

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.auth.data,
  hasErrored: state.auth.hasErrored,
  isLoading: state.auth.isLoading,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js